module.exports = {"id":"165560","name":"Marco Ruben","rating":"77","photo":"./data/images/photos/1/165560.png","club":{"name":"Rosario Central","logo":"./data/images/clubs/RosarioCentral.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarcoRuben0.json
// module id = 2747
// module chunks = 0